const Helper = {
    handleErrors(errorResponse, handler) {
        if (errorResponse instanceof Error) {
            console.log(errorResponse.response);
            handler(errorResponse);
            return false;
        }
        return true;
    },

    getRoomName(room) {
        let title = "";
        if (room == null) return title;

        if (room.first_section != null) {
            title = title + `${room.first_section.title}`;
        }
        if (room.second_section != null) {
            title = title + ` | ${room.second_section.title}`;
        }
        if (room.third_section != null) {
            title = title + ` | ${room.third_section.title}`;
        }
        return title;
    },
    toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    },
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }


}

export default Helper;